/** Import `zod/v4` : évite le prébundle Vite périmé de l’entrée racine `"zod"` (Zod 3 sans `z.uuid`). */
import { z } from 'zod/v4';

const U3134_UUID = z.uuid();
const U3134_REQUIRED_BOOLEAN = z.preprocess(
  (v) => (v === 'true' ? true : v === 'false' ? false : v),
  z.boolean(),
);

/**
 * Champs du formulaire U3134 (`U3134WorkInProgressBody`) toujours non modifiables à l’écran
 * (`fieldDisabled = true` ou affichage lecture seule). Ils ne doivent pas figurer dans le corps POST /update.
 */
export const U3134_UI_NON_EDITABLE_FORM_FIELDS = [
  'project',
  'subproject',
  'clientDisplay',
  'employeeDisplay',
  'taskId',
  'taskCode',
  'taskDescription',
  'transactionKind',
  'honorariumEntryKind',
  'timesheetHonorariumId',
  'timesheetExpenseId',
  'timesheetEquipmentId',
  'expenseTypeCode',
  'expenseTypeDescription',
  'equipmentTypeCode',
  'equipmentTypeDescription',
  'transactionDate',
  'hourly',
  'sellingRate',
  'costRate',
  'quantity',
  'sellingMarkupFactor',
  'costMarkupFactor',
  'unitBaseAmount',
  'amount',
  'costAmount',
  'sellingUnitRate',
  'remark',
  'invoice',
] as const;

/** Seul champ métier modifiable en mode EDIT (TEC non facturée) ; TEC facturée : pas d’appel update. */
export const U3134_UI_UPDATE_ALLOWED_FIELDS = ['id', 'version', 'billable'] as const;

/**
 * Corps POST /U3134/update/:id envoyé par l’UI (strictObject : rejette projectId, remark, montants, etc.).
 * Aligné backend `U3134WorkInProgressLineBillableUpdateSchema`.
 */
export const U3134WorkInProgressLineBillableUpdateSchema = z.strictObject({
  id: U3134_UUID,
  version: z.number(),
  billable: U3134_REQUIRED_BOOLEAN,
});

/** @deprecated Alias historique — même contrat que billable-only. */
export const U3134WorkInProgressLineInvoicedUpdateSchema = U3134WorkInProgressLineBillableUpdateSchema;

export type U3134WorkInProgressLineBillableUpdateParsed = z.infer<typeof U3134WorkInProgressLineBillableUpdateSchema>;
